export function getLanguage(resources: readonly string[]): string {
  const code = navigator.language.split("-")[0];

  const stored = sessionStorage.getItem("language");

  if (stored) return stored;

  return resources.find((key) => key === code) ?? "en";
}
